import React from 'react';
import { SHA256 } from 'crypto-js';

import { listScoringRequests } from '../../services/loanRetrievalService';
import { getCurrentUserEmail } from '../../utils/auth/authenticatedUser';

import Text from '../../components/Text';
import Loader from '../../components/Loader';
import LoanItem from './LoanItem';

import './style.scss';

class LoanList extends React.Component {
  static sortByDateDescending(left, right) {
    const leftApplied = left.dateOriginated || left.dateApplied;
    const rightApplied = right.dateOriginated || right.dateApplied;
    return leftApplied > rightApplied ? -1 : 1;
  }

  constructor(props) {
    super(props);
    this.state = {
      scoringRequests: [],
      fetching: true,
    };
  }

  componentDidMount() {
    this.setState({ fetching: true });
    this.fetchRequestsList();
  }

  fetchRequestsList = async () => {
    const userEmail = await getCurrentUserEmail();
    const hashedUserEmail = SHA256(userEmail).toString();

    listScoringRequests(hashedUserEmail)
      .then((scoringRequests) => {
        this.setState({ scoringRequests, fetching: false });
      })
      .catch((error) => {
        console.error('Error fetching all loans for user:', error); // eslint-disable-line no-console
      });
  };

  render() {
    const { scoringRequests, fetching } = this.state;
    if (fetching) {
      return <Loader />;
    }
    if (!scoringRequests.length) {
      return (
        <div className="no-loans-found-message">
          <h3>
            <Text value="No loans found" />
          </h3>
          <p>
            <Text value="No loans found please contact lender" />
          </p>
        </div>
      );
    }
    return (
      <div className="loanListingContainer">
        <h3>
          <Text value="Loan List" />
        </h3>
        <div className="loanList">
          {scoringRequests
            .sort(LoanList.sortByDateDescending)
            .map((scoringRequest) => (
              <LoanItem
                scoringRequest={scoringRequest}
                key={scoringRequest.requestId}
                history={this.props.history}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default LoanList;
